<div class="card-body table-responsive custom-rounded-table">
  <table class="table table-centered mb-0">
    <thead>
      <tr>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplateMessage.templateName' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplateMessage.preview' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplateMessage.language' | translate }}</th>
        <th class="sr-only">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          {{ selectedTemplate?.name }}
        </td>
        <td>
          {{ $safeNavigationMigration(bodyComponent?.text) | truncate : 50 }}
        </td>
        <td>
          @switch (selectedTemplate?.language) {
            @case ('pt_BR') {
              <span class="d-flex align-items-center gap-2">
                <img width="20" src="../../../../assets/icons/br.svg" [alt]="'attendance.waTemplateMessage.languageAltPt' | translate" />
                <strong>{{ 'attendance.waTemplateMessage.languagePtBR' | translate }}</strong>
              </span>
            }
            @case ('en_US') {
              <span class="d-flex align-items-center gap-2">
                <img width="20" src="../../../../../../../assets/icons/us.svg" [alt]="'attendance.waTemplateMessage.languageAltEn' | translate" />
                <strong>{{ 'attendance.waTemplateMessage.languageEnUS' | translate }}</strong>
              </span>
            }
            @case ('pt_PR') {
              <span class="d-flex align-items-center gap-2">
                <img width="20" src="../../../../../../../assets/icons/pt.svg" [alt]="'attendance.waTemplateMessage.languageAltPtPT' | translate" />
                <strong>{{ 'attendance.waTemplateMessage.languagePtPT' | translate }}</strong>
              </span>
            }
            @case ('pt_PT') {
              <span class="d-flex align-items-center gap-2">
                <img width="20" src="../../../../../../../assets/icons/pt.svg" [alt]="'attendance.waTemplateMessage.languageAltPtPT' | translate" />
                <strong>{{ 'attendance.waTemplateMessage.languagePtPT' | translate }}</strong>
              </span>
            }
            @default {
              {{ selectedTemplate?.language }}
            }
          }
        </td>
        <td class="custom-check-size">
          <i class="ri-checkbox-circle-line text-success display-6"></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="template-area">
  <div class="row">
    @if (headers.controls.length > 0 || bodys.controls.length > 0) {
      <div class="col-7">
        <h3 class="h5 mb-3 text-dark">{{ 'attendance.waTemplateMessage.editVariables' | translate }}</h3>
        <form [formGroup]="formGroup">
          <div formArrayName="headers">
            @for (header of headers.controls; track header; let index = $index) {
              <div class="mb-3" [formGroupName]="index">
                <h5 class="h6">{{ 'attendance.waTemplateMessage.headerVariable' | translate }}</h5>
                <div class="d-flex gap-2 align-items-center">
                  <input class="form-control" type="text" formControlName="value" [placeholder]="'attendance.waTemplateMessage.namePlaceholder' | translate" />
                  <button type="button" class="btn btn-dark d-flex" [matMenuTriggerFor]="menuVar">
                    {{ 'attendance.waTemplateMessage.variables' | translate }}
                  </button>
                  <mat-menu #menuVar="matMenu">
                    @for(variable of variablesFor; track $index ) {
                      <button type="button" mat-menu-item (click)="updateValueForm(variables[variable], index, 'headers')">
                        {{ variable }}
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
          </div>
          <div class="custom-body-variables" formArrayName="bodys">
            @for (body of bodys.controls; track body; let index = $index) {
              <div class="mb-3" [formGroupName]="index">
                <h5 class="h6">{{ 'attendance.waTemplateMessage.variable' | translate }} {{ parameterLabel(bodyParameters, index) }}</h5>
                <div class="d-flex gap-2 align-items-center">
                  <input class="form-control" type="text" formControlName="value" [placeholder]="'attendance.waTemplateMessage.namePlaceholder' | translate" />
                  <button type="button" class="btn btn-dark d-flex" [matMenuTriggerFor]="menuVar">
                    {{ 'attendance.waTemplateMessage.variables' | translate }}
                  </button>
                  <mat-menu #menuVar="matMenu">
                    @for(variable of variablesFor; track $index ) {
                      <button type="button" mat-menu-item (click)="updateValueForm(variables[variable], index, 'bodys')">
                        {{ variable }}
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
          </div>
        </form>
      </div>
    }
    <div class="col-5 custom-template" [ngClass]="{ 'mx-auto' : headers.controls.length === 0 || bodys.controls.length === 0 }">
      <h3 class="h5 mb-4 text-dark">{{ 'attendance.waTemplateMessage.templatePreview' | translate }}</h3>
      <div class="template-area__preview">
        <img src="../../../../../../../assets/images/v2/iphone_mockup.png" alt="" />
        <div class="prev-content custom-scroll-bar">
          @if (!isMedia) {
            <div class="d-flex w-100 align-items-center">
              {{ previewHeader }}
            </div>
          } @else {
              <div class="upload-area">
                @if (loadingSpinnerTemplate$ | async) {
                  <loading-component class="loading" diameter="20" />
                }
                @else {
                  @if (!headerValue) {
                    <label for="dropzone-file-wa-template">
                      <div class="placeholder-content">
                        <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                        <p class="text-primary">{{ 'attendance.waTemplateMessage.uploadPrompt' | translate }}</p>
                        <p class="text-muted">
                          @if(isHeaderImage()) {
                            {{ 'attendance.waTemplateMessage.imageFormatHint' | translate }}
                          } @else if(isHeaderVideo()) {
                            MP4
                          } @else if(isHeaderDocument()) {
                            PDF
                          }
                        </p>
                      </div>
                    </label>
                  }

                  @if(headerValue && typeFile === 'image') {
                    <label for="dropzone-file-wa-template">
                      <img [src]="headerValue" alt="image" />
                    </label>
                  }

                  @if (headerValue && typeFile !== 'image' && typeFile !== 'text') {
                    <a [href]="headerValue" target="_blank">
                      <span class="d-flex gap-3">
                        <img [src]="getIconForContentType()" alt="">
                        <strong>{{ 'attendance.waTemplateMessage.openFile' | translate: { type: typeFile } }}</strong>
                      </span>
                    </a>
                  }

                  <input
                    id="dropzone-file-wa-template"
                    type="file"
                    [accept]="acceptFiles()"
                    (change)="onSelectImagem($event)"
                  />
                }
              </div>
          }

          <p class="my-2">
            {{ previewText }}
          </p>

          <div class="d-flex w-100">
              {{ previewFooter }}
          </div>

          @if (previewButtons.length > 0) {
            <div class="template-buttons w-100">
              @for (button of previewButtons; track $index) {
                <div class="template-buttons__item">
                  @switch (button.type) {
                    @case (ButtonActionsTypeEnum.reply) {
                      <i class="mdi mdi-reply text-success fs-6"></i>
                    }
                    @case (ButtonActionsTypeEnum.call) {
                      <i class="mdi mdi-phone text-success fs-6"></i>
                    }
                    @case (ButtonActionsTypeEnum.url) {
                      <i class="mdi mdi-link text-success fs-6"></i>
                    }
                  }
                  <span class="text-success">{{ button.label }}</span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
